import { API_URL } from "../constants.js";
import axios from 'axios';
import middleware from '../util/middleware';

var request = axios.create({
    baseURL: API_URL,
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
    }
})

/**
 * Clase para ver el request de categorías
 */
class FuenteDemandaRequest {
    /**
     * Llamada el endpoint de django para listar 
     * la fuente de demanda
     * @param: value. id del sitio
     * @param: data. id de la categoría
     * @return: Mensaje de éxito o error.
     */
    static ListarFuenteDemanda(value, modelo, categoria) {
        return middleware.hasAuth(() => request.get(`api/fuente-demanda/${value}/?categoria=${categoria}&tipo_modelo=${modelo}`));
    }

    /**
    * Llamada el endpoint de django para listar 
    * la fuente de demanda de auxiliares
    * @param: value. id del sitio
    */
    static ListarFuenteDemandaAuxiliares(id_sitio) {
        return middleware.hasAuth(() => request.get(`api/fuente-demanda-auxiliares/?sitio_id=${id_sitio}`));
    }

    /**
     * Llamada el endpoint de django para listar 
     * las varibales del modelo de pedido
     * @param: value. id del sitio
     * @param: data. id de la categoría
     * @return: Mensaje de éxito o error.
     */
    static ListarVariablesFuente(value, modelo, categoria) {
        return middleware.hasAuth(() => request.get(`api/sitios/modelo-pedido/${value}/?categoria=${categoria}&tipo_modelo=${modelo}`));
    }

}

export default FuenteDemandaRequest;